import { Header, Message } from "semantic-ui-react";

import Property from "../../rest/Property";
import Card from "../UI/Card/Card";
import OptimisationChart from "./OptimisationChart";
import numberFormatter from "../../numberFormatter";

import "./Co2EnergyOptimisationCard.scss";

interface Co2EnergyOptimisationCardProps {
	property: Property;
}

export default function Co2EnergyOptimisationCard({ property }: Co2EnergyOptimisationCardProps) {
	const sap = property.data.sap_data;

	const co2Data = [
		{
			value: numberFormatter.format(sap.current_co2_rating),
			label: "Current",
			id: "CCO2",
		},
		{
			value: numberFormatter.format(sap.potential_co2_rating - sap.current_co2_rating),
			label: "Potential",
			id: "PCO2",
		},
	];
	const energyData = [
		{
			value: numberFormatter.format(sap.current_energy_rating),
			label: "Current",
			id: "CENG",
		},
		{
			value: numberFormatter.format(sap.potential_energy_rating - sap.current_energy_rating),
			label: "Potential",
			id: "PENG",
		},
	];

	return (
		<Card title="CO2 &amp; Energy Optimisation">
			<Header as="h3">CO2</Header>
			{!property.isPropertyDataNull(["sap_data.current_co2_rating", "sap_data.potential_co2_rating"]) ? (
				<div className="chart-container pie-chart">
					{/* @ts-ignore */}
					<OptimisationChart data={co2Data} />
				</div>
			) : (
				<Message>No CO2 data</Message>
			)}
			<Header as="h3">Energy</Header>
			{!property.isPropertyDataNull(["sap_data.current_energy_rating", "sap_data.potential_energy_rating"]) ? (
				<div className="chart-container pie-chart">
					{/* @ts-ignore */}
					<OptimisationChart data={energyData} />
				</div>
			) : (
				<Message>No Energy data</Message>
			)}
		</Card>
	);
}
